import { render, staticRenderFns } from "./KaijuPayoutStateItem.vue?vue&type=template&id=3a1c878a&"
import script from "./KaijuPayoutStateItem.vue?vue&type=script&lang=ts&"
export * from "./KaijuPayoutStateItem.vue?vue&type=script&lang=ts&"
import style0 from "./KaijuPayoutStateItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports